import React, {useEffect, useState} from "react";
import Content from "../../content-interface";
import Principles from "../principles/Principles";
import styles from "./Question.module.css"
import * as DOMPurify from "dompurify";
import ToggleSwitch from "../toggleSwitch/ToggleSwitch";
import Accordion from "../accordion/Accordion";

const Question = (props: {
  question: Content['questions'][number],
  principles: Content['principles'] | string,
  currAnswer: boolean | undefined,
  answerQuestion: (answer: boolean) => void,
  setError: React.Dispatch<string>,
  nextStep: () => void,
  prevStep: () => void,
}) => {
  const { question, principles, currAnswer, setError } = props;

  const [cleanQuestionHtmlContent, setCleanQuestionHtmlContent] = useState('');
  useEffect(() => {
    if (question?.questionHtmlContent)
      setCleanQuestionHtmlContent(DOMPurify.sanitize(question.questionHtmlContent));
    else
      setError('No question content defined')
  }, [question.questionHtmlContent, setError])

  const onPrev = () => {
    props.prevStep();
  }

  const onNext = () => {
    props.answerQuestion(currAnswer === undefined ? true : currAnswer);
    props.nextStep();
  }

  return (
    <div className="Question">
      <h4>Question</h4>
      <div className={styles.questionContainer}>
        <div className={styles.questionContent} dangerouslySetInnerHTML={{__html: cleanQuestionHtmlContent}}/>
        <ToggleSwitch value={currAnswer === undefined ? true : currAnswer} onSwitch={props.answerQuestion} className={styles.toggleSwitch} id='answer'/>
      </div>

      {question?.hintHtmlContent && <Accordion lightTheme={true} items={[{title: 'Hint', htmlContent: question?.hintHtmlContent || ''}]}/>}

      {principles !== 'all' && typeof principles !== 'string' && <>
        <h4>Governing Principles</h4>
        <Principles principles={principles}/>
      </>}

      {principles === 'all' && <h4>This question pertains to all Governing Principles</h4>}

      <div className="navButtons">
        <button className='light' onClick={onPrev}>Previous</button>
        <button onClick={onNext}>Next</button>
      </div>
    </div>
  );
}

export default Question;
